type Primitive = string | number | boolean | null;

type FieldPredicate = (outputValue: unknown) => boolean;

type FieldMatcher = Primitive | ReadonlyArray<Primitive> | FieldPredicate;

type FieldValues = Record<string, FieldMatcher>;

interface PricingWidgetOutput {
  access_control: string | null;
  data_variable_element: string;
  default_ui_visibility_pw_quote_and_sd_output: string;
  default_ui_visibility_pw_quote_only_output: string;
  input_output: string;
  pw_quote_output_only_order: number | null;
  pw_system_quote_and_sd_order: number | null;
  root: string | null;
  sf_object: string | null;
  source: string | null;
  ui_name: string | null;
  value_type: string | null;
  field_values?: FieldValues | null;
}

export const outputsConstants: PricingWidgetOutput[] = [
  {
    access_control: "All SR Access",
    data_variable_element: "project_state",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 3,
    pw_system_quote_and_sd_order: 3,
    root: null,
    sf_object: "Opportunity",
    source: "Salesforce=Opportunity",
    ui_name: "State",
    value_type: "Text",
  },
  {
    access_control: null,
    data_variable_element: "project_type",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 3.1,
    pw_system_quote_and_sd_order: 3.1,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Project Type",
    value_type: "Text",
  },
  {
    access_control: null,
    data_variable_element: "product_summary",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 3.2,
    pw_system_quote_and_sd_order: 3.2,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Product Summary",
    value_type: "Text",
  },
  {
    access_control: null,
    data_variable_element: "sales_channel",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 4,
    pw_system_quote_and_sd_order: 4,
    root: null,
    sf_object: "Opportunity",
    source: "Salesforce=Opportunity",
    ui_name: "Sales Channel",
    value_type: "Picklist (Channel:Sunstone),(Channel:Other),(DTC)",
  },
  {
    access_control: null,
    data_variable_element: "solver",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 5,
    pw_system_quote_and_sd_order: 5,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Solver",
    value_type: "Text",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "financing_type",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 6,
    pw_system_quote_and_sd_order: 6,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Financing Type",
    value_type: "Picklist (PPA),(Feed-in-Tariff),(Lease)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "ix_delivery_point",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 6.1,
    pw_system_quote_and_sd_order: 6.1,
    root: null,
    sf_object: "SystemDesign",
    source: "Salesforce=SystemDesign",
    ui_name: "IX Delivery Point",
    value_type: "Picklist (FTM),(BTM)",
    field_values: {
      project_state: ["MA", "CT", "RI"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "pv_incentive_program_type",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 6.2,
    pw_system_quote_and_sd_order: 6.2,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PV Incentive Program Type",
    value_type: "Picklist (SMART),(REG),(NRES),(PPA)",
    field_values: {
      project_state: ["MA", "CT", "RI"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "pv_incentive_program_group",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 6.3,
    pw_system_quote_and_sd_order: 6.3,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PV Incentive Program Group",
    value_type: "Picklist (Total Comp),(AOBC),(Buy All),(PPA)",
    field_values: {
      project_state: ["MA", "CT", "RI"],
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "pv_incentive_program_group",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 6.3,
    pw_system_quote_and_sd_order: 6.3,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PV Incentive Program Group",
    value_type: "Picklist (Total Comp),(AOBC),(Buy All),(PPA)",
    field_values: {
      project_state: ["MA", "CT"],
      ix_delivery_point: ["FTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "financial_product_id",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 7,
    pw_system_quote_and_sd_order: 7,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Financial Product ID",
    value_type: "Text",
  },
  {
    access_control: null,
    data_variable_element: "ppa_prod_guar_included",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 8,
    pw_system_quote_and_sd_order: 8,
    root: "financing_type=PPA",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PPA Production Guaranty Included",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: null,
    data_variable_element: "esa_prod_guar_included",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 8.1,
    pw_system_quote_and_sd_order: 8.1,
    root: "financing_type=ESA",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "ESA Production Guaranty Included",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "support_structure_type_primary_sd",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: null,
    pw_system_quote_and_sd_order: 9,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Product System Type",
    value_type:
      "Picklist  (Rooftop Solar),(Carport Solar),(Ground mount Solar)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "rooftop_pv_dc_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 10,
    pw_system_quote_and_sd_order: 10,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Rooftop Solar (kWdc)",
    value_type: "Decimal (7,3)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "carport_pv_dc_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 11,
    pw_system_quote_and_sd_order: 11,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Carport Solar (kWdc)",
    value_type: "Decimal (7,3)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "ground_mount_pv_dc_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 12,
    pw_system_quote_and_sd_order: 12,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Ground Mount Solar (kWdc)",
    value_type: "Decimal (7,3)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "pv_size_dc_kw_sd",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 13,
    pw_system_quote_and_sd_order: 13,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "PV System Size (kWdc)",
    value_type: "Decimal (7,3)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "ac_system_size_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 13.1,
    pw_system_quote_and_sd_order: 13.1,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "AC System Size (kW)",
    value_type: "Decimal (7,3)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "kwh_per_kw_sd",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: null,
    pw_system_quote_and_sd_order: 15,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Productivity (kWh/kW)",
    value_type: "Decimal (4,1)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "battery_storage_incl",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Output",
    pw_quote_output_only_order: null,
    pw_system_quote_and_sd_order: 16,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Battery Storage Included",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "battery_energy_rating_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Output",
    pw_quote_output_only_order: null,
    pw_system_quote_and_sd_order: 17,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Battery Energy Rating (kWh)",
    value_type: "Decimal (7,1)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "battery_pwr_rating_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Output",
    pw_quote_output_only_order: null,
    pw_system_quote_and_sd_order: 18,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Battery Power Rating (kW)",
    value_type: "Decimal (4,1)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "ppa_term_yrs_num",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 19,
    pw_system_quote_and_sd_order: 19,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PPA Term",
    value_type: "Picklist (15),(20),(25)",
    field_values: {
      financing_type: ["PPA", "Feed-in-Tariff"],
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "esa_term_yrs_num",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 19.1,
    pw_system_quote_and_sd_order: 19.1,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "ESA Term",
    value_type: "Picklist (15),(20),(25)",
    field_values: {
      financing_type: ["ESA"],
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "lease_term_yrs_num",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 20,
    pw_system_quote_and_sd_order: 20,
    root: "financing_type=Lease",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Lease Term",
    value_type: "Picklist (15),(20),(25)",
  },
  {
    access_control: null,
    data_variable_element: "custom_useful_life_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 21,
    pw_system_quote_and_sd_order: 21,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom Useful Life Term",
    value_type: "Decimal (2,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "All SR Access",
    data_variable_element: "ppa_pmts_nom_yr1",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 22,
    pw_system_quote_and_sd_order: 22,
    root: "financing_type=PPA",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PPA Payments Year 1",
    value_type: "Currency (7,0)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "lease_annual_rent_yr1",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 23,
    pw_system_quote_and_sd_order: 23,
    root: "financing_type=Lease",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Lease Payment Year 1",
    value_type: "Currency (7,0)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "ppa_escal_orig_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 24,
    pw_system_quote_and_sd_order: 24,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PPA Escalator",
    value_type:
      "Picklist Percent (0.00%),(0.49%),(0.99%),(1.49%),(1.99%),(2.49%),(2.75%),(2.99%)",
    field_values: {
      financing_type: ["PPA", "Feed-in-Tariff"],
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "esa_escal_orig_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 24.2,
    pw_system_quote_and_sd_order: 24.2,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "ESA Escalator",
    value_type:
      "Picklist Percent (0.00%),(0.49%),(0.99%),(1.49%),(1.99%),(2.49%),(2.75%),(2.99%)",
    field_values: {
      ix_delivery_point: ["BTM"],
      project_type: ["Storage-only", "Solar + Storage"],
      financing_type: ["ESA"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "lease_escal_orig_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 24.1,
    pw_system_quote_and_sd_order: 24.1,
    root: "financing_type=Lease",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Lease Escalator",
    value_type:
      "Picklist Percent (0.00%),(0.49%),(0.99%),(1.49%),(1.99%),(2.49%),(2.75%),(2.99%)",
  },
  {
    access_control: "All SR Access",
    data_variable_element: "disc_to_pre_system_utility_bill_pcnt_out",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 25,
    pw_system_quote_and_sd_order: 25,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Annual Discount to Utility Bill (%)",
    value_type: "Percent (2,4)",
    field_values: {
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "dollars_kwh_yr1_ppa",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 25.01,
    pw_system_quote_and_sd_order: 25.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PPA Rate Year 1 ($/kWh)",
    value_type: "Decimal (1,4)",
    field_values: {
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only"],
      financing_type: ["PPA", "Feed-in-Tariff"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "dollars_kwh_yr1_esa",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 25.011,
    pw_system_quote_and_sd_order: 25.011,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "ESA Rate Year 1 ($/kWh)",
    value_type: "Decimal (1,4)",
    field_values: {
      ix_delivery_point: ["BTM"],
      project_type: ["Solar + Storage", "Storage-only"],
      financing_type: ["ESA", "Feed-in-Tariff"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "pv_incentive_program_total_per_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 25.02,
    pw_system_quote_and_sd_order: 25.02,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PV Incentive Program Total Rate ($/kWh)",
    value_type: "Decimal (1,4)",
    field_values: {
      financing_type: ["Feed-in-Tariff"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "awarded_pv_incentive_program_total_per_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 25.03,
    pw_system_quote_and_sd_order: 25.03,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Awarded PV Incentive Program Total Rate ($/kWh)",
    value_type: "Decimal (1,4)",
    field_values: {
      financing_type: ["Feed-in-Tariff"],
      project_state: ["RI", "CT", "MA"],
    },
  },
  {
    access_control: null,
    data_variable_element: "avoided_cost_per_kwh_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 26,
    pw_system_quote_and_sd_order: 26,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Avoided Cost Rate ($/kWh)",
    value_type: "Decimal (1,4)",
    field_values: {
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "All SR Access",
    data_variable_element: "est_bill_savings_yr1",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27,
    pw_system_quote_and_sd_order: 27,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 1",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr2",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.02,
    pw_system_quote_and_sd_order: 27.02,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 2",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr3",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.03,
    pw_system_quote_and_sd_order: 27.03,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 3",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr4",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.04,
    pw_system_quote_and_sd_order: 27.04,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 4",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr5",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.05,
    pw_system_quote_and_sd_order: 27.05,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 5",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr6",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.06,
    pw_system_quote_and_sd_order: 27.06,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 6",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr7",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.07,
    pw_system_quote_and_sd_order: 27.07,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 7",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr8",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.08,
    pw_system_quote_and_sd_order: 27.08,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 8",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr9",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.09,
    pw_system_quote_and_sd_order: 27.09,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 9",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr10",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.1,
    pw_system_quote_and_sd_order: 27.1,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 10",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr11",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.11,
    pw_system_quote_and_sd_order: 27.11,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 11",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr12",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.12,
    pw_system_quote_and_sd_order: 27.12,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 12",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr13",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.13,
    pw_system_quote_and_sd_order: 27.13,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 13",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr14",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.14,
    pw_system_quote_and_sd_order: 27.14,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 14",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr15",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.15,
    pw_system_quote_and_sd_order: 27.15,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 15",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr16",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.16,
    pw_system_quote_and_sd_order: 27.16,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 16",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr17",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.17,
    pw_system_quote_and_sd_order: 27.17,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 17",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr18",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.18,
    pw_system_quote_and_sd_order: 27.18,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 18",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr19",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.19,
    pw_system_quote_and_sd_order: 27.19,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 19",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr20",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.2,
    pw_system_quote_and_sd_order: 27.2,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 20",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr21",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.21,
    pw_system_quote_and_sd_order: 27.21,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 21",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr22",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.22,
    pw_system_quote_and_sd_order: 27.22,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 22",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr23",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.23,
    pw_system_quote_and_sd_order: 27.23,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 23",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr24",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.24,
    pw_system_quote_and_sd_order: 27.24,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 24",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "est_bill_savings_yr25",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 27.25,
    pw_system_quote_and_sd_order: 27.25,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Year 25",
    value_type: "Currency (7,0)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "dollars_kwh_yr1_lease",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 29,
    pw_system_quote_and_sd_order: 29,
    root: "financing_type=Lease",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Rate Year 1 ($/kWh) Lease",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "All SR Access",
    data_variable_element: "est_bill_savings_term_ppa",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 31,
    pw_system_quote_and_sd_order: 31,
    root: "financing_type=PPA",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings PPA Term",
    value_type: "Currency (7,0)",
  },
  {
    access_control: "All SR Access",
    data_variable_element: "est_bill_savings_term_esa",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 31.1,
    pw_system_quote_and_sd_order: 31.1,
    root: "financing_type=ESA",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings ESA Term",
    value_type: "Currency (7,0)",
  },
  {
    access_control: "All SR Access",
    data_variable_element: "est_bill_savings_term_lease",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 32,
    pw_system_quote_and_sd_order: 32,
    root: "financing_type=Lease",
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Estimated Bill Savings Lease Term",
    value_type: "Currency (7,0)",
  },
  {
    access_control: null,
    data_variable_element: "site_lease_included",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 34,
    pw_system_quote_and_sd_order: 34,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease",
    value_type: "Picklist",
  },
  {
    access_control: null,
    data_variable_element: "site_lease_solver_type",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 34.01,
    pw_system_quote_and_sd_order: 34.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease Solver Type",
    value_type: "Picklist",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "site_lease_upfront_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 34.015,
    pw_system_quote_and_sd_order: 34.015,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease Upfront ($)",
    value_type: "Currency (7,2)",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "site_lease_annual_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 34.02,
    pw_system_quote_and_sd_order: 34.02,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Annual Site Lease ($/Yr)",
    value_type: "Currency (7,2)",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "site_lease_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 34.03,
    pw_system_quote_and_sd_order: 34.03,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease Term",
    value_type: "Decimal (2,0)",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "site_lease_initial_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 34.031,
    pw_system_quote_and_sd_order: 34.031,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease Initial Term",
    value_type: "Text",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "site_lease_renewal_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 34.035,
    pw_system_quote_and_sd_order: 34.035,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease Renewal Term",
    value_type: "Decimal (2,0)",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "site_lease_escal",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 34.04,
    pw_system_quote_and_sd_order: 34.04,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Site Lease Escalator",
    value_type: "Picklist",
    field_values: {
      site_lease_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "itc_ineligible_nom_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 35,
    pw_system_quote_and_sd_order: 35,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "ITC Ineligible Cost ($)",
    value_type: "Currency (7,2)",
  },
  {
    access_control: null,
    data_variable_element: "dev_budget_override",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 35.5,
    pw_system_quote_and_sd_order: 35.5,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "PD Budget Override",
    value_type: "Picklist",
  },
  {
    access_control: null,
    data_variable_element: "dev_budget_exp_adjust_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 36,
    pw_system_quote_and_sd_order: 36,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Development Budget Expense Adjustment ($)",
    value_type: "Currency (7,2)",
    field_values: {
      dev_budget_override: ["No"],
    },
  },
  {
    access_control: null,
    data_variable_element: "dev_budget_exp_adjust_nom_out",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 36.01,
    pw_system_quote_and_sd_order: 36.01,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Development Budget Expense Adjustment ($)",
    value_type: "Currency (7,2)",
    field_values: {
      dev_budget_override: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "epc_total_per_watt_sd",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37,
    pw_system_quote_and_sd_order: 37,
    root: null,
    sf_object: "System Design",
    source: null,
    ui_name: "EPC Total ($/W)",
    value_type: "Currency (7,4)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "epc_bess_per_kwh_sd",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37.01,
    pw_system_quote_and_sd_order: 37.01,
    root: null,
    sf_object: "System Design",
    source: null,
    ui_name: "EPC BESS ($/kWh)",
    value_type: "Currency (7,4)",
    field_values: {
      project_type: ["Storage-only"],
    },
  },
  {
    access_control: null,
    data_variable_element: "epc_total_nom_sum",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Output",
    pw_quote_output_only_order: 37.03,
    pw_system_quote_and_sd_order: 37.03,
    root: null,
    sf_object: "System Design",
    source: null,
    ui_name: "EPC Total Nom Sum",
    value_type: "Currency (1,2)",
  },
  {
    access_control: null,
    data_variable_element: "pv_installer_cost_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37.035,
    pw_system_quote_and_sd_order: 37.035,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "PV Installer Cost ($)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "bess_installer_cost_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37.036,
    pw_system_quote_and_sd_order: 37.036,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "BESS Installer Cost ($)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "pv_sunrock_procurement",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37.04,
    pw_system_quote_and_sd_order: 37.04,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "PV Sunrock Procurement ($)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "bess_sunrock_procurement",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37.05,
    pw_system_quote_and_sd_order: 37.05,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "BESS Sunrock Procurement ($)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "third_party_dev_cost_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 37.06,
    pw_system_quote_and_sd_order: 37.06,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Project Development Cost $ Nominal",
    value_type: "Currency (1,2)",
  },
  {
    access_control: null,
    data_variable_element: "epc_delta_sr_epc_inst_epc_per_watt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 38,
    pw_system_quote_and_sd_order: 38,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Sunrock vs Installer EPC Delta $",
    value_type: "Currency (7,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "rec_type",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 40,
    pw_system_quote_and_sd_order: 40,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "REC Type",
    value_type: "Picklist",
    field_values: {
      project_state: ["NJ", "IL", "VA", "MI", "IN", "KY", "NC", "TN"],
    },
  },
  {
    access_control: null,
    data_variable_element: "rec_group",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 41,
    pw_system_quote_and_sd_order: 41,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "REC Group",
    value_type: "Picklist",
    field_values: {
      project_state: ["NJ", "IL", "VA", "MI", "IN", "KY", "NC", "TN"],
    },
  },
  {
    access_control: null,
    data_variable_element: "state_incentive_yr1_nom_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 42,
    pw_system_quote_and_sd_order: 42,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "State Incentive Upfront $",
    value_type: "Currency (7,2)",
  },
  {
    access_control: null,
    data_variable_element: "offtaker_holds_rec_rights",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 43,
    pw_system_quote_and_sd_order: 43,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Offtaker Holds REC Rights",
    value_type: "Picklist",
    field_values: {
      financing_type: ["PPA", "Lease"],
    },
  },
  {
    access_control: null,
    data_variable_element: "awarded_pv_incentive_program_total_per_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Output",
    pw_quote_output_only_order: 44,
    pw_system_quote_and_sd_order: 44,
    root: null,
    sf_object: "Quote",
    source: null,
    ui_name: "Awarded PV Incentive Program Total Rate",
    value_type: "Currency (1,4)",
    field_values: {
      project_state: ["RI", "CT"],
      ix_delivery_point: ["FTM"],
    },
  },
  {
    access_control: null,
    data_variable_element: "decommission_bond_applies",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 45,
    pw_system_quote_and_sd_order: 45,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Decommission Bond Applies",
    value_type: "Picklist",
  },
  {
    access_control: null,
    data_variable_element: "decommission_bond_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 45.01,
    pw_system_quote_and_sd_order: 45.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Decommissioning Bond Nominal Size",
    value_type: "Currency (7,2)",
    field_values: {
      decommission_bond_applies: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "utility_name",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 46,
    pw_system_quote_and_sd_order: 46,
    root: null,
    sf_object: "Opportunity",
    source: "Salesforce=Opportunity",
    ui_name: "Utility Name",
    value_type: "Text",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "rate_class",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 46.01,
    pw_system_quote_and_sd_order: 46.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Rate Class",
    value_type: "Text",
    field_values: {
      project_state: ["MA"],
      financing_type: ["Feed-in-Tariff"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "greenfield_subtractor",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 47,
    pw_system_quote_and_sd_order: 47,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Greenfield Subtractor",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      project_state: ["MA"],
      financing_type: ["Feed-in-Tariff"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "acreage",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 47.01,
    pw_system_quote_and_sd_order: 47.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Acreage",
    value_type: "Text",
    field_values: {
      greenfield_subtractor: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "public_school",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 48,
    pw_system_quote_and_sd_order: 48,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Public School",
    value_type: "Picklist",
    field_values: {
      project_state: ["IL"],
    },
  },
  {
    access_control: null,
    data_variable_element: "public_school",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 48.01,
    pw_system_quote_and_sd_order: 48.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Public School",
    value_type: "Picklist",
    field_values: {
      project_state: ["CT"],
      ix_delivery_point: ["FTM"],
    },
  },
  {
    access_control: null,
    data_variable_element: "community_type",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 49,
    pw_system_quote_and_sd_order: 49,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Community Type",
    value_type: "Picklist",
    field_values: {
      project_state: ["CT"],
      ix_delivery_point: ["FTM"],
    },
  },
  {
    access_control: null,
    data_variable_element: "public_entity",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 50,
    pw_system_quote_and_sd_order: 50,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Public Entity",
    value_type: "Picklist",
    field_values: {
      project_state: ["NJ"],
    },
  },
  {
    access_control: null,
    data_variable_element: "itc_adder_domestic_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 51,
    pw_system_quote_and_sd_order: 51,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Domestic ITC Adder Eligible",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: null,
    data_variable_element: "itc_adder_domestic_pv_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 51.003,
    pw_system_quote_and_sd_order: 51.003,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PV Domestic ITC Adder Eligible",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "itc_adder_domestic_bess_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 51.006,
    pw_system_quote_and_sd_order: 51.006,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "BESS Domestic ITC Adder Eligible",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "itc_adder_energy_com_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 51.01,
    pw_system_quote_and_sd_order: 51.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Energy Community ITC Adder Eligible",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: null,
    data_variable_element: "itc_adder_low_inc_qt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 51.02,
    pw_system_quote_and_sd_order: 51.02,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Low Income ITC Adder Eligible",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: null,
    data_variable_element: "pv_itc_safeharbored",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 51.03,
    pw_system_quote_and_sd_order: 51.03,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "PV ITC Safe Harbored",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "state_incentive_yr1_nom_sd",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 52,
    pw_system_quote_and_sd_order: 52,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "State Incentive Upfront $",
    value_type: "Currency (7,2)",
  },
  {
    access_control: null,
    data_variable_element: "pricing_model_upfront_incentive",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 53,
    pw_system_quote_and_sd_order: 53,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Pricing Model Upfront Incentive ($)",
    value_type: "Currency (7,2)",
  },
  {
    access_control: null,
    data_variable_element: "building_mount_smart_adder_per_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 54,
    pw_system_quote_and_sd_order: 54,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Building Mount SMART Adder $/kWh",
    value_type: "Currency",
    field_values: {
      project_state: ["MA"],
      financing_type: ["Feed-in-Tariff"],
    },
  },
  {
    access_control: null,
    data_variable_element: "canopy_smart_adder_per_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 55,
    pw_system_quote_and_sd_order: 55,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Canopy SMART Adder $/kWh",
    value_type: "Currency",
    field_values: {
      project_state: ["MA"],
      financing_type: ["Feed-in-Tariff"],
    },
  },
  {
    access_control: null,
    data_variable_element: "itc_pcnt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 56,
    pw_system_quote_and_sd_order: 56,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "ITC Percentage",
    value_type: "Percent (2,0)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 57,
    pw_system_quote_and_sd_order: 57,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Financing Dev Fee $",
    value_type: "Currency (1,4)",
  },
  {
    access_control: null,
    data_variable_element: "sr_finl_dev_fee_solar_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 57.01,
    pw_system_quote_and_sd_order: 57.01,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Solar Financing Dev Fee $",
    value_type: "Currency (7,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "sr_finl_dev_fee_bess_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 57.02,
    pw_system_quote_and_sd_order: 57.02,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock BESS Financing Dev Fee $",
    value_type: "Currency (7,2)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_per_watt_upfront",
    default_ui_visibility_pw_quote_and_sd_output: "No",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58,
    pw_system_quote_and_sd_order: 58,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Upfront Financing Development Fee ($/W)",
    value_type: "Currency (1,4)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_nominal_upfront",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.01,
    pw_system_quote_and_sd_order: 58.01,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Upfront Dev Fee $",
    value_type: "Currency (1,4)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_d_1_net_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.02,
    pw_system_quote_and_sd_order: 58.02,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Investor Total Draw 1 Net $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_d_2_net_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.03,
    pw_system_quote_and_sd_order: 58.03,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Investor Total Draw 2 Net $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_d_3_net_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.04,
    pw_system_quote_and_sd_order: 58.04,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Investor Total Draw 3 Net $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_net_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.05,
    pw_system_quote_and_sd_order: 58.05,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Dev Fee Investor Total Net Fee $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_net_upfr_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.06,
    pw_system_quote_and_sd_order: 58.06,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Dev Fee Investor Total Net Upfront $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_net_def_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.07,
    pw_system_quote_and_sd_order: 58.07,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Dev Fee Investor Total Net Deferred $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_grs_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.08,
    pw_system_quote_and_sd_order: 58.08,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Dev Investor Total Fee Gross $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_adj_appl",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.09,
    pw_system_quote_and_sd_order: 58.09,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Investor Dev Fee Adjustment Applies",
    value_type: "Picklist",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_finl_dev_fee_inv_total_adj_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 58.10,
    pw_system_quote_and_sd_order: 58.10,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Sunrock Dev Investor Total Fee Adjustment $",
    value_type: "Currency (1,2)",
    field_values: {
      sr_finl_dev_fee_adj_appl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "inverter_extended_warr_per_watt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 59,
    pw_system_quote_and_sd_order: 59,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Inverter Extended Warranty ($/W)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "referral_fees_total_per_watt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 60,
    pw_system_quote_and_sd_order: 60,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Total Channel and Referral Partner Referral Fees ($/W)",
    value_type: "Currency (1,4)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "sr_trans_legal_fees_per_watt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 61,
    pw_system_quote_and_sd_order: 61,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Transaction/Legal Fees ($/W)",
    value_type: "Currency (1,4)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "dev_only_expense_budget_total_per_watt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 62,
    pw_system_quote_and_sd_order: 62,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Development Expenses Only Budget Total ($/W)",
    value_type: "Currency (1,4)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "referral_fees_total_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 63,
    pw_system_quote_and_sd_order: 63,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Total Channel and Referral Partner Referral Fees $",
    value_type: "Currency (7,2)",
  },
  {
    access_control: null,
    data_variable_element: "sr_trans_legal_fees_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 64,
    pw_system_quote_and_sd_order: 64,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Transaction/Legal Fees $",
    value_type: "Currency (7,2)",
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "dev_only_expense_budget_total_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 65.04,
    pw_system_quote_and_sd_order: 65.04,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Development Expenses Only Budget Total $",
    value_type: "Currency (1,2)",
  },
  {
    access_control: null,
    data_variable_element: "dev_budget_override",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 65.01,
    pw_system_quote_and_sd_order: 65.01,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "PD Budget Override",
    value_type: "Picklist",
  },
  {
    access_control: null,
    data_variable_element: "dev_budget_exp_adjust_nom",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 65.02,
    pw_system_quote_and_sd_order: 65.02,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Development Budget Expense Adjustment ($)",
    value_type: "Currency (7,2)",
    field_values: {
      dev_budget_override: ["No"],
    },
  },
  {
    access_control: null,
    data_variable_element: "dev_budget_exp_adjust_nom_out",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 65.03,
    pw_system_quote_and_sd_order: 65.03,
    root: null,
    sf_object: "Budget",
    source: "Pricing Widget",
    ui_name: "Development Budget Expense Adjustment ($)",
    value_type: "Currency (7,2)",
    field_values: {
      dev_budget_override: ["Yes"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "opp_maintain_cost_escal",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 66,
    pw_system_quote_and_sd_order: 66,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "O&M Escalator",
    value_type: "Percent (2,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "opp_maintain_cost_yr1_per_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 67,
    pw_system_quote_and_sd_order: 67,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "O&M Year 1 ($/kW)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "opp_maintain_cost_yr6_per_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 67.04,
    pw_system_quote_and_sd_order: 67.04,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "O&M Years 6+ ($/kW)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: "Engineering & Finance Only",
    data_variable_element: "opp_maintain_cost_yr1_per_kwh",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Output",
    pw_quote_output_only_order: 67.10,
    pw_system_quote_and_sd_order: 67.10,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "BESS O&M Year 1 ($/kWh)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "custom_opp_maintain_cost_applies",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 68,
    pw_system_quote_and_sd_order: 68,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom O&M",
    value_type: "Picklist",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "custom_opp_maintain_cost_yr1_per_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 68.01,
    pw_system_quote_and_sd_order: 68.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom O&M Cost Year 1 ($/kW)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "custom_opp_maintain_cost_yr6_per_kw",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 68.06,
    pw_system_quote_and_sd_order: 68.06,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom O&M Cost Year 6 ($/kW)",
    value_type: "Currency (1,2)",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "custom_opp_maintain_cost_escal",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 69,
    pw_system_quote_and_sd_order: 69,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom O&M Cost Escalator",
    value_type: "Picklist",
    field_values: {
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "disc_to_pre_system_utility_bill_pcnt_inp",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 70,
    pw_system_quote_and_sd_order: 70,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Annual Discount to Utility Bill (%) INPUT",
    value_type: "Percent (2,4)",
    field_values: {
      ix_delivery_point: ["BTM"],
      project_type: ["Solar-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "unilateral_auto_renewal",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 70,
    pw_system_quote_and_sd_order: 70,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Unilateral Auto-Renewal",
    value_type: "Picklist (Yes),(No)",
  },
  {
    access_control: null,
    data_variable_element: "property_tax_exempt",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 72,
    pw_system_quote_and_sd_order: 72,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Property Tax Exempt",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      ix_delivery_point: ["FTM"],
      project_state: ["MA"],
    },
  },
  {
    access_control: null,
    data_variable_element: "es_system_coupling",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 73,
    pw_system_quote_and_sd_order: 73,
    root: null,
    sf_object: "System Design",
    source: "Salesforce=SystemDesign",
    ui_name: "Storage system coupling",
    value_type: "Picklist (AC),(DC)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "extended_battery_life_product",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 74,
    pw_system_quote_and_sd_order: 74,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Extended Battery Life Product",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "es_oem",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 75,
    pw_system_quote_and_sd_order: 75,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Battery OEM",
    value_type: "Text",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_warranty_default",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76,
    pw_system_quote_and_sd_order: 76,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Default Storage Warranty Term?",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_warranty_custom_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76.01,
    pw_system_quote_and_sd_order: 76.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom Storage Warranty Term",
    value_type: "Picklist (5),(15),(20),(25)",
    field_values: {
      battery_storage_incl: ["Yes"],
      storage_warranty_default: ["No"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_warranty_custom_cost",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76.02,
    pw_system_quote_and_sd_order: 76.02,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Custom Storage Warranty Cost",
    value_type: "Currency (10,0)",
    field_values: {
      battery_storage_incl: ["Yes"],
      storage_warranty_default: ["No"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_incentive_program",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76.03,
    pw_system_quote_and_sd_order: 76.03,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Storage Incentive Programs",
    value_type: "Text",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_incentive_upfront_amount",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76.04,
    pw_system_quote_and_sd_order: 76.04,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Upfront Incentive Amount ($)",
    value_type: "Text",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_incentive_perf_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76.05,
    pw_system_quote_and_sd_order: 76.05,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Performance Incentive Term (Years)",
    value_type: "Text",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_incentive_perf_amount",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 76.06,
    pw_system_quote_and_sd_order: 76.06,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Performance Incentive Amount ($)",
    value_type: "Text",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "storage_additional_proj_diligence_req",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 77,
    pw_system_quote_and_sd_order: 77,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Additional Project Diligence Required (Y/N)",
    value_type: "Picklist (Yes),(No)",
    field_values: {
      battery_storage_incl: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "standalone_storage_avoided_cost",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28,
    pw_system_quote_and_sd_order: 28,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Annual Savings ($)",
    value_type: "Currency (10,2)",
    field_values: {
      project_type: ["Storage-only"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "disc_to_standalone_storage_avoided_cost_inp",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.01,
    pw_system_quote_and_sd_order: 28.01,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Annual Savings Discount (%) Input",
    value_type: "Percent (2,4)",
    field_values: {
      project_type: ["Storage-only"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "disc_to_standalone_storage_avoided_cost_out",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.02,
    pw_system_quote_and_sd_order: 28.02,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Annual Savings Discount (%)",
    value_type: "Percent (2,4)",
    field_values: {
      project_type: ["Storage-only"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "capacity_payment_included",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.03,
    pw_system_quote_and_sd_order: 28.03,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Capacity Payment (yes/no)",
    value_type: "Text",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
    },
  },
  {
    access_control: null,
    data_variable_element: "capacity_payment_rate",
    default_ui_visibility_pw_quote_and_sd_output: "No",
    default_ui_visibility_pw_quote_only_output: "No",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.04,
    pw_system_quote_and_sd_order: 28.04,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Capacity Payment Rate ($/kW-month)",
    value_type: "Currency (10,4)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "capacity_payment_term",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.05,
    pw_system_quote_and_sd_order: 28.05,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Capacity Payment Term (years)",
    value_type: "Text",
    field_values: {
      project_type: ["Storage-only"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "capacity_payment_escalator",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.06,
    pw_system_quote_and_sd_order: 28.06,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Capacity Payment Escalator (%)",
    value_type: "Percent (3,2)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "capacity_payment_rate_yr1",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.07,
    pw_system_quote_and_sd_order: 28.07,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Capacity Payment Rate ($/kW-month) Year 1",
    value_type: "Currency (10,2)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
      capacity_payment_included: ["Yes"],
    },
  },
  {
    access_control: null,
    data_variable_element: "capacity_payments_annual_yr1",
    default_ui_visibility_pw_quote_and_sd_output: "Yes",
    default_ui_visibility_pw_quote_only_output: "Yes",
    input_output: "Input/Output",
    pw_quote_output_only_order: 28.08,
    pw_system_quote_and_sd_order: 28.08,
    root: null,
    sf_object: "Quote",
    source: "Pricing Widget",
    ui_name: "Total Capacity Payments ($) Year 1",
    value_type: "Currency (10,2)",
    field_values: {
      project_type: ["Storage-only", "Solar + Storage"],
      capacity_payment_included: ["Yes"],
    },
  },
];
